import { TEMPLATE_TYPES, TEMPLATES } from "utils/constants";
import AdherentBirthDate from "../../Comparison/Amellis/AdherenBirthdate";
import AdherentInfo from "../../Comparison/Amellis/AdherentInfo";
import AdherentTelecoms from "../../Comparison/Amellis/AdherentTelecoms";
import BankInformation from "../../Comparison/Amellis/BankInformation";
import Loading from "../../Comparison/Amellis/Components/Loader";
import Default from "../../Comparison/Amellis/Default";
import EffectiveDate from "../../Comparison/Amellis/EffectiveDate";
import ElectronicSignature from "../../Comparison/Amellis/ESign";
import GenerateESignDocumentsWithoutPrice from "../../Comparison/Amellis/GenerateESignDocumentsWithRequiredNotice";
import Justification from "../../Comparison/Amellis/Justification";
import Needs from "../../Comparison/Amellis/Needs";
import ProductsPerBeneficiaryWithoutPrice from "../../Comparison/Amellis/ProductsPerBeneficiaryWithoutPrice";
import RelatedPersons from "../../Comparison/Amellis/RelatedPersons";
import SelectBranch from "../../Comparison/Amellis/SelectBranch";
import SelectCollectivity from "../../Comparison/Amellis/SelectCollectivity";
import SocialSecurityNumber from "../../Comparison/Amellis/SocialSecurityNumber";
import SubscriptionDone from "../../Comparison/Amellis/SubscriptionDone";

const Templates = {
  Loading: <Loading />,
  [TEMPLATES.COLLECTIVE.THEMES[TEMPLATE_TYPES.B2C_COLLECTIVE_AMELLIS].PROFILE]:
    SelectCollectivity,
  [TEMPLATES.COLLECTIVE.THEMES[TEMPLATE_TYPES.B2C_COLLECTIVE_AMELLIS]
    .SELECT_BRANCH]: SelectBranch,
  [TEMPLATES.COLLECTIVE.THEMES[TEMPLATE_TYPES.B2C_COLLECTIVE_AMELLIS]
    .ADHERENT_BIRTHDATE]: AdherentBirthDate,
  [TEMPLATES.COLLECTIVE.THEMES[TEMPLATE_TYPES.B2C_COLLECTIVE_AMELLIS].NEEDS]:
    Needs,
  [TEMPLATES.COLLECTIVE.THEMES[TEMPLATE_TYPES.B2C_COLLECTIVE_AMELLIS]
    .ADHERENT_INFO]: AdherentInfo,
  [TEMPLATES.COLLECTIVE.THEMES[TEMPLATE_TYPES.B2C_COLLECTIVE_AMELLIS].PRODUCTS]:
    ProductsPerBeneficiaryWithoutPrice,
  [TEMPLATES.COLLECTIVE.THEMES[TEMPLATE_TYPES.B2C_COLLECTIVE_AMELLIS]
    .EFFECTIVE_DATE]: EffectiveDate,
  [TEMPLATES.COLLECTIVE.THEMES[TEMPLATE_TYPES.B2C_COLLECTIVE_AMELLIS]
    .ADHERENT_TELECOMS]: AdherentTelecoms,
  [TEMPLATES.COLLECTIVE.THEMES[TEMPLATE_TYPES.B2C_COLLECTIVE_AMELLIS]
    .ADHERENT_SOCIAL_SECURITY_NUMBER]: SocialSecurityNumber,
  [TEMPLATES.COLLECTIVE.THEMES[TEMPLATE_TYPES.B2C_COLLECTIVE_AMELLIS]
    .RELATED_PERSONS]: RelatedPersons,
  [TEMPLATES.COLLECTIVE.THEMES[TEMPLATE_TYPES.B2C_COLLECTIVE_AMELLIS]
    .ADHERENT_BANK_INFORMATION]: BankInformation,
  [TEMPLATES.COLLECTIVE.THEMES[TEMPLATE_TYPES.B2C_COLLECTIVE_AMELLIS]
    .GENERATE_E_SIGN_DOCUMENTS]: GenerateESignDocumentsWithoutPrice,
  [TEMPLATES.COLLECTIVE.THEMES[TEMPLATE_TYPES.B2C_COLLECTIVE_AMELLIS].E_SIGN]:
    ElectronicSignature,
  [TEMPLATES.COLLECTIVE.THEMES[TEMPLATE_TYPES.B2C_COLLECTIVE_AMELLIS]
    .JUSTIFICATIONS]: Justification,
  [TEMPLATES.COLLECTIVE.THEMES[TEMPLATE_TYPES.B2C_COLLECTIVE_AMELLIS]
    .SUBSCRIPTION_DONE]: SubscriptionDone,
  default: Default,
};
export default Templates;
